import { useEffect, useRef, useState } from "react";
import NewToolTip from "../NewToolTip";
import classes from "./miniboost.module.css";
import cx from "classnames";

function MiniBoostTag(props) {
  const { toolTipUrgentHiring, tipClass, boostContent } = props;
  const [showUrgentHiringTooltip, setUrgentHiringTooltip] = useState(false);

  const urgentHiringRef = useRef(null);

  const onUrgentHiringClick = e => {
    // const element = urgentHiringRef.current;
    // const headerOffset = 120;
    // const elementPosition = element.getBoundingClientRect().top;
    // const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    // window.scrollTo({
    //   top: offsetPosition,
    //   behavior: "smooth"
    // });

    e.stopPropagation();
    setUrgentHiringTooltip(true);
  };

  if (boostContent) {
    return (
      <div ref={urgentHiringRef} className={classes.root}>
        <span className="text-indigo-500 bg-indigo-50 p-1 px-2 text-sm font-semibold  rounded-lg">
          Limited time offer
        </span>

        <img
          src="/hire/urgent-hiring-info.svg"
          width={16}
          height={16}
          alt="urgent-hiring-info icon"
          className={classes.urgentHiringIcon}
          onClick={e => onUrgentHiringClick(e)}
          onMouseOver={e => onUrgentHiringClick(e)}
        />
        {showUrgentHiringTooltip && (
          <NewToolTip
            rootClass={
              toolTipUrgentHiring
                ? cx(toolTipUrgentHiring, classes.toolTipUrgentHiring)
                : classes.toolTipUrgentHiring
            }
            tipClass={
              tipClass ? cx(tipClass, classes.tipClass) : classes.tipClass
            }
            isClose={false}
            showTip={true}
            handleClose={() => setUrgentHiringTooltip(false)}
            tipUrl={"/hire/tipUp.svg"}
            keepScrollEvent={false}
            keepOutsideClickEvent={false}
          >
            <div className={cx(classes.tipContainer)}>
              <div
                className={classes.close}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  setUrgentHiringTooltip(false);
                }}
              >
                <img
                  src="/hire/close_gray.svg"
                  height={12}
                  width={12}
                  alt="close icon"
                />
              </div>
              {/* <div className={classes.urgentHiringWarning}>
                <img
                  src="/hire/warning-clock.svg"
                  width={12}
                  height={12}
                  alt="warning clock icon"
                  className={classes.clockIcon}
                />
                1 Job Boost
              </div> */}
              <div>
                <div className={cx(classes.heading, "px-2 !mt-2 mr-2")}>
                  Increase your Premium jobs visibility for 24 hours and reach
                  even more candidates
                </div>
                <div className="flex items-center flex-row border-t mt-1 pt-2 pl-2 ">
                  <img src="/hire/access_time.svg" alt="" />
                  <span className="ml-2 font-normal text-gray-500 text-xs md:text-xs ">
                    Boost will be available 24 hrs after your job is made live
                  </span>
                </div>
              </div>
            </div>
          </NewToolTip>
        )}
      </div>
    );
  }

  return null;
}

export default MiniBoostTag;
